// extracted by mini-css-extract-plugin
module.exports = {"header-brand":"HeaderBrand_header-brand__2mc2l"};